export const flattenPages = (data, key) =>
  (data?.pages || []).flatMap((page) => page?.[key] || [])
